import React from "react";

export const SvgListingNewHomes = () => {
	return (
		<svg
			width="105"
			height="47"
			viewBox="0 0 105 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_17182_22250)">
				<rect
					x="10"
					y="7"
					width="84.1689"
					height="26.736"
					rx="4"
					fill="#5D83E8"
				/>
			</g>
			<path
				d="M27.0269 16.7398V23.9414H25.8665L22.4731 19.036H22.4133V23.9414H21.1088V16.7398H22.2762L25.666 21.6487H25.7293V16.7398H27.0269ZM29.4386 23.9414V16.7398H34.1225V17.8334H30.7432V19.7885H33.8798V20.8821H30.7432V22.8478H34.1506V23.9414H29.4386ZM37.9592 23.9414L35.9268 16.7398H37.3298L38.6274 22.032H38.6942L40.0796 16.7398H41.3561L42.7451 22.0355H42.8084L44.1059 16.7398H45.509L43.4765 23.9414H42.1895L40.7478 18.8883H40.6915L39.2463 23.9414H37.9592ZM50.8502 23.9414V16.7398H52.1548V19.7885H55.4919V16.7398H56.8V23.9414H55.4919V20.8821H52.1548V23.9414H50.8502ZM65.6442 20.3406C65.6442 21.1166 65.4988 21.7812 65.2081 22.3344C64.9198 22.8853 64.5259 23.3073 64.0266 23.6003C63.5296 23.8933 62.9658 24.0399 62.3352 24.0399C61.7046 24.0399 61.1396 23.8933 60.6403 23.6003C60.1433 23.3049 59.7495 22.8818 59.4588 22.3309C59.1704 21.7776 59.0263 21.1142 59.0263 20.3406C59.0263 19.5646 59.1704 18.9012 59.4588 18.3503C59.7495 17.7971 60.1433 17.3739 60.6403 17.0809C61.1396 16.7878 61.7046 16.6413 62.3352 16.6413C62.9658 16.6413 63.5296 16.7878 64.0266 17.0809C64.5259 17.3739 64.9198 17.7971 65.2081 18.3503C65.4988 18.9012 65.6442 19.5646 65.6442 20.3406ZM64.3325 20.3406C64.3325 19.7944 64.247 19.3337 64.0758 18.9586C63.9071 18.5812 63.6726 18.2964 63.3726 18.1042C63.0725 17.9096 62.7267 17.8123 62.3352 17.8123C61.9437 17.8123 61.5979 17.9096 61.2979 18.1042C60.9978 18.2964 60.7622 18.5812 60.5911 18.9586C60.4223 19.3337 60.3379 19.7944 60.3379 20.3406C60.3379 20.8868 60.4223 21.3486 60.5911 21.7261C60.7622 22.1011 60.9978 22.386 61.2979 22.5806C61.5979 22.7728 61.9437 22.8689 62.3352 22.8689C62.7267 22.8689 63.0725 22.7728 63.3726 22.5806C63.6726 22.386 63.9071 22.1011 64.0758 21.7261C64.247 21.3486 64.3325 20.8868 64.3325 20.3406ZM67.8678 16.7398H69.4642L71.6022 21.9581H71.6866L73.8246 16.7398H75.421V23.9414H74.1692V18.9938H74.1024L72.1121 23.9203H71.1767L69.1864 18.9833H69.1196V23.9414H67.8678V16.7398ZM77.8319 23.9414V16.7398H82.5157V17.8334H79.1365V19.7885H82.2731V20.8821H79.1365V22.8478H82.5439V23.9414H77.8319Z"
				fill="white"
			/>
			<defs>
				<filter
					id="filter0_d_17182_22250"
					x="0.0977726"
					y="0.0684414"
					width="103.976"
					height="46.5408"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="2.97067" />
					<feGaussianBlur stdDeviation="4.95111" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_17182_22250"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_17182_22250"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
